export function applyRdcStyling(styles: string | undefined, styleId: string): string | undefined {
  // styles is a colon-separated list of style parameters, if a styleId is present
  // we want to replace the style name (the first one) with `RANA_STYLE__${styleId}`.

  if (!styles) {
    return `RANA_STYLE__${styleId}`;
  }

  const styleParts = styles.split(":");
  styleParts[0] = `RANA_STYLE__${styleId}`;
  return styleParts.join(":");
}
